// extracted by mini-css-extract-plugin
module.exports = {"UsedDuringDisasters":"UsedDuringDisasters_UsedDuringDisasters__5JUIC"};